// 根据该模块下的个文件名，来做归类区分：
const ja = {
	group: {
		groupManagement: 'Webサイトグループ管理',
		omniGroupManagement: 'グループ管理',
		CREATEGROUP: 'グループ作成',
		website: '登録ウェブサイト',
		store: '店舗数',
		addWebsite: 'Webサイト追加',
		detail: '詳細',
		noWebsite: '登録サイトはありません。Webサイトを追加してください。',
		noStore: 'まだストアをお持ちでない場合は、ストアを作成してください。',
		groupName: 'グループ名',
		cancel: 'キャンセル',
		create: '作成する',
		singleAdd: '単一の追加',
		batchAdd: '一括追加',
		batchAddTittle: 'Web サイトをバッチで追加する',
		label: 'ウェブサイトのテンプレートファイルの形式に従って情報を入力し、アップロードしてください',
		download: 'ウェブサイトテンプレートをダウンロード',
		add: '新規追加',
		message: 'ファイルがアップロードされていません'
	},
	groupDetail: {
		settlementCurrency: '決済通貨',
		searchStoreName: 'Webサイト',
		omniSearchStoreName: 'ウェブサイト・店舗',
		index: 'No.',
		storeName: 'Webサイト',
		omniStoreName: '店舗 / ウェブサイト名',
		accId: 'WebサイトID',
		omniAccId: '店舗/ウェブサイトID',
		storeUrl: 'WebサイトURL',
		storeType: '店舗タイプ',
		action: '操作',
		detail: 'ウェブサイトの詳細',
		modifyGroupName: 'グループ名の変更',
		groupName: 'グループ名',
		comfirm: '確認する',
		edit: '編集',
		copy: 'コピー',
		message: 'グループ名が正常に変更されました。'
	},
	webManagement: {
		noWebsite: 'まだサイトを追加していません',
		addWebsite: 'Webサイト追加',
		pleaseSubmitName: '最初に実名認証を送信してください',
		needSubmitName: '最初に実名認証を送信してから、Web サイトを追加する必要があります',
		groupNeedKYC: '最初に実名認証を送信してから、グループを追加する必要があります',
		submitName: '実名資料の提出',
		contact: 'カスタマーサービスにお問い合わせください',
		contactToAdd: 'Web サイトを追加するにはカスタマー サービスにお問い合わせください',
		noSuportAddBySelf: '現時点では、Web サイトを個別に追加することはサポートされていません。カスタマー サービスにお問い合わせください。レビュー資料の提出についてご案内いたします。ご迷惑をおかけして誠に申し訳ございません。',
		visible: '表示中のWebサイト',
		hidden: '非表示のWebサイト',
		storeNameUrl: 'ウェブサイト名/ウェブサイトURL',
		hideWebsite: 'Webサイトを非表示にする',
		delete: '削除',
		hideTip: 'Web サイトを非表示に設定すると、このリストには表示されなくなります。 「非表示の Web サイト」をクリックすると表示されます。',
		hide: '非表示にする',
		cancel: 'キャンセル',
		deleteTip: 'ウェブサイトを削除する',
		sureDelete: 'この Web サイトを削除してもよろしいですか?',
		unHide: '再表示',
		unHideReason: '再表示することを確認します',
		hideReason: '非表示にする理由',
		success: '操作は成功しました',
		confirm: '確認する',
		bindShopify: '物流結合',
		unBindShopify: '物流のアンバンドリング',
		unlinkText: 'Shopifyとの連携が解除されました。物流情報を自動的に同期するには、Shopify管理画面でPingPong Connectアプリをインストールしてください。',
		linkIndependent: '物流結合',
		unlinkIndependent: '物流のアンバンドリング',
		domain: 'ドメイン名を入力してください',
		appToken: 'アプリトークンを入力してください',
		independent: '連携プラットフォーム',
		linkStatus: '結合状態',
		webName: 'Webサイト',
		webUrl: 'サイトURL',
		onlyShopify: '現在、このシステムへのリンクは Shopify/Woocommerce/Shoplazza の Web サイト構築プラットフォームのみがサポートされており、他のプラットフォームは開発中です。',
		linksuccess: 'バインド成功',
		linkedTooltip: '%{website} アカウントに連携済みです：%{host}',
		linkedTooltipWithStatus: '物流は連携済みです。%{website} アカウントに連携済みです：%{host}',
		unlinkBodyText:
			'<p><b>%{storeName}</b> と %{website} の連携を解除してもよろしいですか？</p><p>解除後、システムは物流情報を自動取得できなくなり、手動でアップロードする必要があります。</p>',
		unlinkBodyTextForWebsite:
			'<p>ウェブサイト <b>%{storeName}</b> と %{website} の連携を解除してもよろしいですか？</p><p>解除後、システムは物流情報を自動取得できなくなり、手動でアップロードする必要があります。</p>',
		linkBodyText:
			'<p><b>%{storeName}</b> を %{website} に連携すると、システムが物流情報を自動で取得できるようになり、手動アップロードは不要になります。</p>',
		linkBodyTextForWebsite:
			'<p>ウェブサイト <b>%{storeName}</b> を %{website} に連携すると、システムが物流情報を自動で取得できるようになり、手動アップロードは不要になります。</p>',
		linkSuccessBodyText:
			'<p>ウェブサイト <b>%{storeName}</b> は %{website} に連携されました。システムが物流情報を自動で取得するため、手動アップロードは不要です。</p>',
		linkSuccessMessage: '連携成功',
		unlinkSuccessMessage: '連携解除成功',
		accIdLabel: 'Acc ID',
		consumerKeyLabel: 'Consumer Key：',
		consumerSecretLabel: 'Consumer Secret：',
		commentWithResubmit: '%{comment}、%{tip}',
		allWebsiteOption: 'すべて',
		linkedStatusUnlinked: '未連携',
		linkedStatusLinked: '連携済み',
		searchResultText: 'キーワード「%{keyword}」に関する検索結果が %{total} 件見つかりました',
		searchSuggestText: 'ウェブサイトが見つからない場合は、<b>非表示のウェブサイト</b> を確認してください',
		autoUpload: '物流同期操作ガイド',
		wooTip: 'この URL は、デフォルトで WooCommerce によって割り当てられる URL であり、Web サイトの認証に使用されます。正しくご記入ください。',
		require: 'しなければならない',
		applePayDomainVerify: 'Apple Pay ドメイン認証',
		applePayVerifiedTips: 'このウェブサイトは Apple Pay 認証済みです',
		applePayDomainDesc: 'PingPongホステッドチェックアウトまたは支払いリンクを利用している場合、このドメイン認証ステップはスキップできます。埋め込みチェックアウトや Pay button など、他の統合方式では Apple Pay を利用する前にドメイン認証が必要です。',
		applePayStep1Title: 'ステップ1：認証ファイルをダウンロード',
		applePayStep1Desc: 'Apple が提供するドメイン認証ファイルをダウンロードしてください。このファイルは、ドメインの所有権を証明するために使用されます。',
		applePayDownloadVerifyFile: '認証ファイルをダウンロード',
		applePayStep2Title: 'ステップ2：ファイルをサイトへアップロード',
		applePayStep2Desc: 'ダウンロードした認証ファイルをサイトの指定パスにアップロードしてください。Apple はこのパスにアクセスしてドメイン所有権を確認します。Apple Pay ボタンを表示するすべてのサイトに同ファイルを配置してください。',
		applePayUploadPath: 'アップロードパス：あなたのドメイン/.well-known/apple-developer-merchantid-domain-association',
		applePayStep3Title: 'ステップ3：ドメインを認証',
		applePayStep3Desc: 'ステップ2でファイルアップロードが完了したドメインを追加して認証してください。認証成功後、そのドメインで Apple Pay を利用できます。',
		applePayAddDomain: 'ドメインを追加',
		applePayVerifiedDomain: '認証済みドメイン',
		applePayDomainVerifySuccess: 'ドメイン認証に成功しました',
		applePayDomainVerifyFail: 'ドメイン認証に失敗しました',
		applePayDomainInvalid: '正しいドメインを入力してください',
		deleteApplePayDomainTip: 'この操作により、検証済みのドメイン %{domain} が削除されます。続行しますか？',
		deleteApplePayDomainTipTitle: 'ヒント'
	},
	addWebDialog: {
		addWebsite: 'Webサイト追加',
		webSiteName: 'Webサイト',
		writeSiteName: 'ウェブサイト名を入力してください',
		websiteUrl: 'WebサイトURL',
		storeLink: 'プラットフォームストアのリンク',
		storeLinkPlaceholder: 'Amazon、eBay、その他のプラットフォームのストア リンク',
		writeWebsiteUrl: 'ウェブサイトのホームページのドメイン名を入力してください',
		backHome: 'ホームページに戻る',
		title: 'ウェブサイトが見つからない場合は、',
		desc: 'ウェブサイトが見つからない場合は、カスタマーサービスにお問い合わせください',
		contactText: 'カスタマーサービスにお問い合わせください:pp@pingpongx.com',
		cancel: 'キャンセル',
		add: '新規追加',
		cancelAdd: 'サイトの追加をキャンセルする',
		cancelFont: '現在ウェブサイトを追加していません。 Web サイトの追加をキャンセルすると、レビューの進行状況に影響を与える可能性があります。キャンセルを確認しますか？',
		secondCancelFont: 'まだ提出していません。編集を続けますか?',
		yes: 'キャンセルの確認',
		no: 'もう一度考えてみます',
		closePage: 'ページを閉じる',
		confirm: '確認'
	},
	addStore: {
		tradeType: '取引タイプ',
		tradeTypeOfWebsite: 'Webサイト取引種別',
		submitWebsite: 'ウェブサイトを審査の​​ために送信する',
		omniSubmitWebsite: 'Webサイト管理',
		report: '監査報告書',
		storeName: '店舗名（英語入力のみ対応）',
		group: '所属するウェブサイトグループ',
		omniGroup: '所属グループ',
		routeWebsiteGroup: 'サイトグループを作成する',
		omniRouteWebsiteGroup: 'グループ作成',
		knownGroupTip: 'サイトのグループ化について学ぶ',
		omniKnownGroupTip: 'グループについて',
		knownGroupTipText: 'Web サイトのグループ化を使用すると、会社の地域、ビジネスなどの権限を分離したり、複数の Web サイトからのデータを結合して分析したりできます。そうでない場合は、デフォルトの管理が使用されます。',
		omniKnownGroupTipText: 'グループ管理を使用すると、会社の地域、ビジネスなどの権限を分離したり、複数の Web サイトやストアなどからのデータを結合および分析したりできます。必要がない場合は、デフォルトの管理が使用されます。',
		applicationForm: '加盟店申込フォーム',
		applicationFormDesc: '申込書をダウンロードして必要事項を記入・署名の上、アップロードしてください。',
		businessType: '取引種別',
		pleaseSelect: '選択してください',
		noFlowNoHistort: '独立したウェブサイト運営経験はありませんが、Amazon、eBayなどのプラットフォームでの運営歴はあります',
		hasFlowOrHasHistory: '申請されたWebサイト/アプリにはすでにトランザクションフローが存在します',
		websiteFlow: '取引履歴',
		websiteUrl: 'WebサイトURL',
		independentWebsite: '連携プラットフォーム',
		summaryReport: '過去3～6ヶ月以内の【クレジットカードご利用明細】（実際にWeb上で発生したもの）',
		submitReport: 'PayPal、Stripe、Google Play、またはその他の決済代行業者（PSP）の明細には、月間の取引額、チャージバック率、返金率などの情報が含まれている必要があります。',
		picture: '画像ファイル',
		fitFiels: 'EXCELまたはPDFファイル',
		bankStatement: '過去 3 ～ 6 か月間の e コマース プラットフォームでの取引明細',
		ifFirstBussiness: 'Amazonの取引明細など',
		websiteUrlProvide: 'ドメイン登録証明書',
		websiteUrlProvideDesc: '特定のドメイン名、ドメイン名購入者、有効期間などの情報を反映する必要がある、Web サイトのドメイン名の購入記録およびその他の情報を提供してください。',
		submitMes: '送信',
		cancel: 'キャンセル',
		getFail: '情報を取得できませんでした。管理者に連絡してください',
		pleaseSubmit: 'アップロードしてください',
		relevantDocs: '関連資料',
		closeField: '関連資料',
		submitSuccess: '送信成功',
		submitFail: '送信に失敗しました。もう一度お試しください',
		checking: 'ウェブサイトの情報は検討中です。しばらくお待ちください。',
		checkPass: 'ウェブサイトの情報が審査され、承認されました',
		checkFail: '送信された Web サイト情報は、データが欠落しているか情報が間違っているため、審査に落ちました。再提出してください。',
		checkNotFit: '残念ながら、現在あなたには資格がありません。',
		additional: '追加情報',
		pleaseUploadFlow: '取引証明書をアップロードしてください',
		pleaseWriteName: '店舗名をご記入ください。最大長は 240 文字です。',
		pleaseWriteUrl: 'Web サイトの URL を入力してください。最大 240 文字がサポートされています',
		pleaseWriteLink: 'プラットフォームストアのリンクを入力してください',
		pleaseWriteLinkRule: 'サポートされる最大文字数は 240 文字です',
		_independentWebsite: '選択してください',
		pleaseUploadApplication: '販売者申請フォームをアップロードしてください',
		pleaseSelectType: 'ウェブサイトの種類を選択してください',
		pleaseUploadFlowWeb: 'ウェブサイトのフローファイルをアップロードしてください',
		pleaseMoneyReport: '財務諸表書類をアップロードしてください',
		pleaseUploadBild: '銀行取引明細書ファイルをアップロードしてください',
		pleaseUploadProvide: 'ウェブサイトのドメイン名登録証明書をアップロードしてください',
		searchSuccess: 'クエリが成功しました',
		addSuccess: 'おめでとうございます。Web サイトが正常に追加されました',
		addFailed: '申し訳ありませんが、追加に失敗しました',
		inLength: '長さは 2 ～ 100 文字です',
		pleaseSelectGroup: '所属するグループを選択してください',
		warnTip: ['あなたの会社が次の要件を満たしていることを確認してください。', '1) 対象要件: 本土/香港/ヨーロッパ/米国の企業 (個人ではない)。', '2) 国境を越えた電子商取引の経験がある: 独立系 Web サイト運営者、またはプラットフォーム上の大手販売者が独立系 Web サイトに切り替えるなど。', '3) 国境を越えた実践的基盤を有する: Dazhu、PayPal、およびその他の取得取引を含むがこれらに限定されない、月間取引高が 100,000 米ドル以上である必要があります。', '4) チャージバックは制御可能であり、CB は 1% 以下です。', '5) サイト外団体、模倣品、未配達等の好ましくない営業形態。'],
		transactionHistory: '過去の取引証明',
		transactionHistoryTip: 'プラットフォーム上での過去の取引の証拠、6～12 か月間の [クレジット カード取引明細書] (プラットフォーム上で実際に発生したもの)。例: PayPal またはその他の決済サービスプロバイダーからの明細書と取引の詳細。月々の取引量、チャージバック率、詐欺率、返金率などの情報が反映されます。',
		financialDoc: '財務証明（オプション）',
		financialDocTip: '会社の財務状況を証明するもの。',
		websiteDoc: 'Web サイトのドメイン名証明書',
		websiteDocTip: '次の重要な情報を含める必要があります: ドメイン名のフルネーム、ドメイン名所有者/登録者の情報、ドメイン名の登録日、ドメイン名の有効期限、ドメイン名登録機関の情報。',
		pci: 'PCI資格',
		pciTip: 'ペイメント カード <br/>業界データ セキュリティ基準 (PCI DSS)<br/> のコンプライアンス認証ドキュメント。',
		dueDiligence: '適当な注意',
		dueDiligenceTip: 'プラットフォームのレビュー基準/ポリシーとサブマーチャント向けのデューデリジェンスプロセス。',
		prohibitedItems: '禁止品および制限品のリスト',
		prohibitedItemsTip: 'プラットフォーム独自の禁止および制限された商品のリスト。',
		disputeProcedures: '紛争調査資料',
		disputeProceduresTip: 'プラットフォームの紛争調査手順または消費者の苦情処理メカニズム。',
		riskMonitoring: 'リスク監視ポリシー',
		riskMonitoringTip: 'プラットフォームのリスク管理メカニズムには以下が含まれますが、これらに限定されません。 <br/>(1) リスク監視ポリシーおよび手順の文書化されたバージョン。 <br/>(2) プラットフォーム販売者を毎日監視します。 <br/>(3) プラットフォームとプラットフォーム販売者間のマージンポリシー。 <br/>(4) プラットフォーム販売者に対する報酬と罰のメカニズム (撤退メカニズムを含む)。 <br/>(5) 疑わしい取引を報告します。',
		required: 'ファイルをアップロードしてください'
	},
	webDetail: {
		webMan: 'ウェブサイトを審査の​​ために送信する',
		omniWebMan: 'Webサイト管理',
		transRecord: '取引履歴',
		moneyFlow: '資本の流れ',
		marginFlow: 'マージンフロー',
		chargebackRecord: 'チャージバック履歴',
		chooseDate: '日付を選択してください',
		date: '期間',
		quicklySelect: 'クイック選択',
		today: '今日',
		lastWeek: '先週',
		lastMonth: '先月',
		lastYear: '去年',
		searchWebOrder: 'ウェブサイトの注文番号を検索',
		transType: '取引タイプ',
		transState: '取引状況',
		transCurrency: '取引通貨',
		searchTransFlow: 'トランザクションのシリアル番号を検索する',
		downloadRecord: 'CSV',
		businessType: '取引種別',
		inOrOut: '入出金',
		all: '全て',
		in: '収入',
		out: '支出',
		preAuthorizationConfirmationSuccess: '事前承認が正常に確認されました',
		preAuthorizationConfirmationFailure: '事前承認の確認に失敗しました',
		refundSuccess: '払い戻しが成功しました',
		refundFailure: '返金に失敗しました',
		preAuthorizationSuccess: '事前認証が成功しました',
		preAuthorizationFailure: '事前認証に失敗しました',
		AuthorizationSuccess: '認可成功',
		successPayment: '支払いが成功しました',
		failedPayment: '支払いに失敗しました',
		recordedPayment: '入金成功',
		preAuthorizationCancellationSuccessfully: '事前認証が正常にキャンセルされました',
		preAuthorizationCancellationFailure: '事前承認のキャンセルに失敗しました',
		processing: '支払い中です',
		reviewed: '審査待ち',
		cancelled: '取引の取り消し',
		currency: '取引通貨',
		transactionTime: '取引日時',
		refundTime: '返金日時',
		transactionID: 'シリアルナンバー',
		orderID: 'サイト注文番号',
		omniOrderID: '販売者の注文番号',
		shopifyOrderId: 'Shopify注文番号',
		client: 'ユーザー',
		merchantId: 'ユーザーID',
		amount: '取引金額',
		status: '取引状況',
		download: 'ダウンロード',
		moreDetail: 'もっと見る',
		change: '変更',
		settlementAmount: '出金額',
		inputTip: '出金額を入力してください',
		Minimum: '最低出金額100元',
		// all: "全部",
		replacement: '出金口座の変更',
		application: '出金申請が成功しました〜',
		withdrawSuccessful: '無事に出金完了',
		confirmChange: '交換の確認',
		depositAmount: '証拠金の額',
		checkRemittance: '今日の支払いを表示する',
		withdrawal: '出金',
		copy: 'コピー',
		websiteInforamtion: 'ウェブサイトの詳細',
		copyed: 'クリップボードにコピーされました',
		copyfailed: 'コピーに失敗しました。後でもう一度お試しください',
		settlementNum: '出金可能残高',
		allFunds: '全額',
		paymentToday: '今日は支払いが行われていません',
		paymentTip: '本日あなたの銀行口座に紐づく推定支払額は次のとおりです。',
		withdrawalFee: '出金手数料',
		estimatedTransferredAmount: '受取予定金額',
		confirm: '確認する',
		nodata: 'データなし',
		transactionType: '取引タイプ',
		threeDS: '3DS認証',
		token: 'トークンの支払い',
		issueCountry: 'カード発行国',
		errorMessage: '失敗理由の割合',
		threeDS2: '3DS',
		token2: 'Token',
		paymentBrand: '支払方法',
		createTime: '作成日時',
		fixedFee: '固定料金',
		attention: 'ご注意',
		attentionLine1: '中継銀行および受取銀行の手数料により、実際の受取金額がシステム上の予定金額と異なる場合があります。当該手数料は中継銀行および受取銀行により決定されます。',
		attentionLine2: '海外送金を行う場合、中継銀行および受取銀行により送金手数料が請求され、受取人に口座開設手数料が請求される場合があります。これらの手数料は送金金額から差し引かれます。送金が受取銀行から返還された場合、上記手数料は仲介銀行および受取銀行から返金されません。これに異議がある場合は、仲介銀行、受取銀行または受取人にご相談ください。',
		groupName: 'グループ',
		storeName: 'Webサイト',
		storeGroupName: 'Webサイト / グループ',
		omniStoreGroupName: '店舗/ウェブサイト/グループ',
		refundOrderId: '返金番号',
		storeRefundFlowId: 'サイト返金番号',
		platformShareBenefitFee: 'サブアカウントの金額',
		platformShareBenefitCurrency: '口座通貨',
		pos: 'POS SN',
		mid: 'MID',
		tid: 'TID',
		rrn: 'RRN',
		tips: 'この取引は手動返金のみをサポートしており、次の追加情報が必要です',
		tips2: '選択した銀行のみが返金をサポートできます',
		bankName: '銀行名',
		accountName: '銀行口座名',
		accountNumber: '銀行口座番号',
		paymentSlip: '支払い伝票',
		tradeVoucherId: '取引伝票番号',
		paymentSlipSample: '支払伝票の例',
		downloadPaymentSlip: 'ダウンロード',
		tradeVoucherIdSample: '取引伝票番号の取得方法については、支払伝票例を参照してください。',
		button: {
			confirm: '確認する',
			bind: '連携',
			unbind: '連携解除',
			cancel: 'キャンセル',
			continue: '続行'
		}
	},
	withdrawModal: {
		formRules: '金額が引き出し可能な金額を超えています。確認してもう一度開始してください。',
		formRules2: '正しい金額を入力してください (小数点以下 2 桁のみ使用可能)',
		refundRule: '金額が返金可能な金額を超えています。確認して、もう一度開始してください。',
		success: '操作は成功しました',
		failed: '操作が失敗しました',
		add: '追加に移動',
		noWithdrawals: '現金の引き出しができない',
		noAccount: '出金口座が追加されていないか、追加された出金口座がこの通貨をサポートしていません。出金を開始する前に追加してください。'
	},
	tradeDetail: {
		omniStoreRefundFlowId: '販売者返金シリアル番号',
		webDetail: 'ウェブサイトの詳細',
		tadeDetail: '取引詳細',
		refund: '返金',
		disbursement: '支払いを要求する',
		// 预授权请款
		authVoid: 'キャンセル',
		// 预授权撤销
		authVoidTip: 'このトランザクションを {0} {1} の金額でキャンセルしてもよろしいですか?',
		authCaptureTip: 'このトランザクションを完了するために {0} {1} をリクエストしてもよろしいですか?',
		transactionStatus: '注文関連レコード',
		transactionInformation: '取引情報',
		transactionTime: '取引日時',
		amount: '取引金額',
		paymentDetails: '元の注文情報',
		paymentMethod: '支払方法',
		cardNumber: '支払いカード番号',
		accountHolder: '所有者名',
		cardIssuingCountry: 'カード発行国',
		preAuthorizationConfirmation: '事前承認の確認',
		preAuthorizationCancellation: '事前承認のキャンセル',
		refundAccount: '返金済み',
		refundAmount: '返金額',
		refundFee: '返品手数料',
		refundMargin: '返却デポジット',
		orderAccount: '注文入力',
		totalAmount: '合計金額',
		incomingAmount: '入力金額',
		fee: '料金',
		securityDeposit: 'マージン',
		// amount: '金额',
		transactionCancelledSuccessfully: 'トランザクションは正常にキャンセルされました',
		transactionCancellationfailed: 'トランザクションのキャンセルに失敗しました',
		refunding: '返金中です',
		riskReview: 'リスク管理レビュー保留中',
		inTransaction: '取引',
		totalConfirmation: '事前承認確認総額',
		totalRefundAmount: '払い戻し総額',
		transactionFee: '取引手数料',
		refundFree2nd: '払戻手数料',
		accountfunds: '残高口座資金の変更',
		remainingAmount: 'この取引の残りの返金可能な金額',
		refundTips1st: 'ここで開始した払い戻しの場合、払い戻し記録はウェブサイトと同期されません。',
		refundTips2nd: '払い戻しを開始するには、ウェブサイトにアクセスしてください。',
		refundTips3nd: 'この資金は通常のルートでは返金できませんので、返金先の銀行情報をご記入ください。',
		captureTips1st: 'ここで開始した支払いリクエストの場合、支払い記録は Web サイトと同期されません。',
		captureTips2nd: 'ウェブサイトにアクセスして支払いリクエストを開始してください。',
		accountName: '銀行口座名',
		accountNumber: '銀行口座',
		bankCode: '銀行コード',
		remainAmount: 'この取引の確認可能な残高',
		confirmPayment: 'トランザクションがキャンセルされると、元に戻すことはできません。',
		cinfirmCancel: '取引をキャンセルしてもよろしいですか?',
		cancelPayment: '取引をキャンセルする',
		cancelStatus: 'キャンセルが成功しました',
		riskOrder: '危険な注文はその後のチャージバックにつながり、ビジネスに影響を与える可能性があります。注文にリスクがないことを確認しますか?',
		riskReviews: '取引には危険が伴います。PingPong による審査を待っています',
		riskReviewC: 'この取引には危険が伴い、販売者による審査が保留されています。',
		cancelFont: '注文をキャンセルしてもよろしいですか?トランザクションがキャンセルされると、元に戻すことはできません。',
		risky: '取引にはリスクがありますので、必ずご確認ください',
		riskyTips1: 'お願いします',
		riskyTips2: '事前にカード所有者に連絡して確認し、有効期限が切れた場合、取引は自動的にキャンセルされます。',
		accept: '取引を受け入れる',
		cancel: 'もう一度考えてみます',
		cancelDeal: '取引をキャンセルする',
		riskOrderReject: 'リスク注文のレビューと拒否',
		appeal: '代表権を放棄する',
		appealFont: '異議申し立てを放棄してもよろしいですか?一度諦めてしまうと再度異議を申し立てることはできませんので、慎重に判断してください。',
		cancelAppeal: 'もう一度考えてみます',
		chargeBackTip: 'チャージバックの場合は返金不可',
		refundOrderId: '返金番号',
		storeRefundFlowId: 'サイト返金番号',
		origintransactionId: '元の取引注文番号',
		shippingAddress: 'お届け先の住所',
		shippingPhone: '荷受人の電話番号',
		email: '荷受人のメールアドレス',
		issue: 'カード発行銀行',
		moreDetail: '詳細'
	},
	capitalFlow: {
		all: '全て',
		Payment: '支払い',
		paymentFee: '決済手数料',
		reserveHolding: 'マージンで保有',
		refund: '返金',
		refundFee: '返金手数料',
		depositRelease: '敷金返還',
		depositExpireRelease: '満期時の預金の返還',
		chargebackDeduction: 'チャージバック',
		chargebackCancellation: 'チャージバック',
		chargebackFee: 'チャージバック手数料',
		chargebackSuppFee: '段階的な手数料の支払いの拒否',
		withdrawal: '出金',
		withdrawalFee: '出金手数料',
		depositReleaseCancellation: '保証金返還のキャンセル',
		flowID: 'シリアルナンバー',
		time: '期間',
		incomingAmount: '所得金額',
		outcomingAmount: '支出金額',
		accountBalance: '口座残高',
		businessType: '取引種別',
		chargebackArbitrationFee: '仲裁手数料の支払い拒否',
		chargebackReturn: '仲裁手数料の支払いと返品の拒否'
	},
	depositFlow: {
		incomingDeposit: '新しい余白を追加する',
		depositReleaseForRefund: '敷金返還',
		depositBalance: '満期時の預金の返還'
	},
	chargeBack: {
		appealDate: 'アピールタイム',
		chargebackDate: 'チャージバック日時',
		chargebackFlowID: '支払い拒否シリアル番号',
		transactionID: '取引番号',
		appealStatus: '異議申立結果',
		search: '検索',
		cardNumber: 'カード番号',
		chargebackReason: 'チャージバックの理由',
		amount: '取引金額',
		currency: '取引通貨',
		transactionTime: '取引日時',
		chargebackAmount: 'チャージバック金額',
		chargebackCurrency: 'チャージバック通貨',
		operation: '操作',
		chargebackAppeal: 'チャージバックに対する異議申し立て',
		chargebackCase: 'チャージバックに対して異議を申し立ててもよろしいですか?',
		startDate: '開始日',
		endDate: '終了日'
	},
	tradeType: {
		debit: '決済',
		refund: '返金',
		auth: '事前認証',
		capture: '事前認証完了',
		void: '事前認可の取り消し',
		authCapture: '事前承認された要求',
		approve: '審査通過',
		reject: 'レビュー拒否',
		processing: '処理',
		pending: '支払い中です',
		success: '成功',
		failed: '失敗',
		canceled: 'キャンセル',
		review: '審査待ち',
		tradeTime: '取引日時',
		tradeType: '取引タイプ',
		tradeStatus: '取引状況',
		operator: '操作',
		exportExcel: '現在の結果をエクスポートする',
		tableField: '表示項目の設定',
		fixedField: '固定フィールド',
		optionalField: 'オプションのフィールド',
		saveSeting: '設定を保存する',
		yes: 'はい',
		no: 'いいえ',
		save: '正常に保存されました',
		savefaile: '保存できませんでした。後でもう一度お試しください',
		risky: '取引にはリスクがありますので、必ずご確認ください',
		riskyTips1: 'お願いします',
		riskyTips2: '事前にカード所有者に連絡して確認し、有効期限が切れた場合、取引は自動的にキャンセルされます。',
		accept: '取引を受け入れる',
		cancel: '取引をキャンセルする',
		currentDetails: '現在の詳細',
		details: '詳細',
		tradeNum: 'シリアルナンバー',
		refundNum: '返金番号',
		riskOrder: '危険な注文はその後のチャージバックにつながり、ビジネスに影響を与える可能性があります。注文にリスクがないことを確認しますか?',
		riskReviews: '取引には危険が伴います。PingPong による審査を待っています',
		riskReviewC: 'この取引には危険が伴い、販売者による審査が保留されています。',
		cancelFont: '注文をキャンセルしてもよろしいですか?トランザクションがキャンセルされると、元に戻すことはできません。',
		arn: 'ARN',
		failReason: '失敗理由の割合',
		failCode: 'エラーコード'
	},
	tradeChannelRefund: {
		areaCode: '国番号',
		areaCodeRequired: '国番号を選択してください',
		accountType: 'タイプ',
		accountName: '銀行口座名',
		accountHolder: '名前',
		accountNumber: '銀行口座',
		email: 'メールアドレス',
		phoneNo: '電話番号',
		phoneRequired: '電話番号を入力してください',
		nationalId: 'ID番号'
	},
	storeOnboarding: {
		title: 'ストアステータスのクエリ',
		mcc: '加盟店カテゴリー',
		storeStatus: '店舗状況',
		location: 'エリア',
		submerchantId: 'ストアID',
		submerchantName: '店名',
		storeUrl: 'ストアリンク',
		businessIdentityNumber: '法人番号',
		businessAddress: '住所',
		brand: 'ブランド名',
		createTime: '作成日時',
		updateTime: '更新日時',
		search: '検索',
		reset: 'リセット',
		all: '全て',
		close: '無効にする',
		open: '正常'
	}
}
export default ja
